import { CustomerTypesInversedKeys } from '@teinor/erp/types/company/customer/customerTypes'
import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'
import { ReduxCustomerTypes } from '../../reducers/customers/customer'
import { getConfigParam } from '../../reducers/getters'
import { CompanyTypeOfCustomersTyInversed } from '@teinor/erp/types/company/config/parameter'
import locations from '../../globals/locations'
import { useCallback, useMemo } from 'react'


const useCustomerTypesDict = (myFilterCustomer?: number) => {
    const { t } = useTwinTranslation()
    const haveLeads = getConfigParam('haveLeads') === 'on' ? true : false
    const companyTypeOfCustomers = myFilterCustomer ? parseInt(String(myFilterCustomer)) : parseInt(String(getConfigParam('companyTypeOfCustomers')))
    const dictCustomerTypeBase: Record<CustomerTypesInversedKeys, TwinDictionary> = {
        0: { name: t('B2C', 'B2C') },
        1: { name: t('B2B', 'B2B') },
        2: { name: t('leadB2B', 'Potencial B2B') },
        3: { name: t('leadB2C', 'Potencial') }
    }
    const dictCustomerTypeShort: TwinDictionary = {
        0: { name: t('B2C', 'B2C') },
        1: { name: t('B2B', 'B2B') },
    }

    const dictCustomerTypeTrans: Record<ReduxCustomerTypes, string> = {
        'customers': t('customers', 'Clientes'),
        'customersB2B': t('customersB2B', 'Clientes B2B'),
        'contactsB2B': t('leadsB2B', 'Clientes Potenciales B2B'),
        'contactsB2C': t('leadsB2C', 'Potenciales'),
    }
    let dictCustomerTypeCompleteWithoutLeads: TwinDictionary = {
        0: { name: t('B2C', 'B2C'), colorText: '#EF661D' },
        1: { name: t('B2B', 'B2B'), colorText: '#054BAD' },
    }
    let dictCustomerTypeComplete: TwinDictionary = {
        0: { name: t('B2C', 'B2C'), colorText: '#EF661D' },
        1: { name: t('B2B', 'B2B'), colorText: '#054BAD' },
        2: { name: t('leadB2B', 'Potencial B2B'), colorText: '#0090EB' },
        3: { name: t('leadB2CLong', 'Potencial B2C'), colorText: '#BA63D4' }
    }
    let dictCustomerTypeFilter: TwinDictionary = {}
    if (companyTypeOfCustomers === CompanyTypeOfCustomersTyInversed['B2C']) {
        dictCustomerTypeFilter[0] = { name: t('customer', 'Cliente')}
        dictCustomerTypeComplete[0].name = t('customer', 'Cliente')
        if (haveLeads) {
            dictCustomerTypeFilter[3] = { name: t('lead', 'Potencial')}
            dictCustomerTypeComplete[3].name = t('lead', 'Potencial')
        }
    }else if (companyTypeOfCustomers === CompanyTypeOfCustomersTyInversed['B2B']) {
        dictCustomerTypeFilter[1] = { name: t('customer', 'Cliente')}
        dictCustomerTypeComplete[1].name = t('customer', 'Cliente')
        if (haveLeads) {
            dictCustomerTypeFilter[2] = { name: t('lead', 'Potencial')}
            dictCustomerTypeComplete[2].name = t('lead', 'Potencial')
        }
    } else {
        if(haveLeads){
            dictCustomerTypeFilter = dictCustomerTypeComplete
        }else {
            dictCustomerTypeFilter = dictCustomerTypeCompleteWithoutLeads
        }
    }
    const dictCustomerType: TwinDictionary = dictCustomerTypeBase
    const customerGroupsTypesDict: Record<number, string> = {
        0: 'B2CCustomerGroups',
        1: 'B2BCustomerGroups',
        2: 'B2BContactGroups',
        3: 'B2CContactGroups'
    }

    const dictTypeCustomerLink: Record<CustomerTypesInversedKeys, string> = {
        0: 'customers',
        1: 'customersB2B',
        2: 'contactsB2B',
        3: 'contacts',
    }
    
    return { dictCustomerType, dictCustomerTypeTrans, dictCustomerTypeComplete, dictCustomerTypeFilter, customerGroupsTypesDict, dictCustomerTypeShort, dictTypeCustomerLink }
}

export const useCustomerParsedLinkGet = () => {
    const { dictTypeCustomerLink } = useCustomerTypesDict()

    const getParsedCustomerLink = useCallback((id: number, customer_type: CustomerTypesInversedKeys) => {
        const showAllCustomersTogether = getConfigParam('showAllCustomersTogether') === 'on' ? true : false
        return locations.customer + '/' + (showAllCustomersTogether ? 'allCustomers' : dictTypeCustomerLink[customer_type as CustomerTypesInversedKeys]) + '/' + id + '/main'
    }, [dictTypeCustomerLink])
    
    return { getParsedCustomerLink }
}

interface CustomerParsedLinkMemoProps {
    id: number
    customer_type: CustomerTypesInversedKeys
}
export const useCustomerParsedLinkMemo = ({ id, customer_type }: CustomerParsedLinkMemoProps) => {
    const { getParsedCustomerLink } = useCustomerParsedLinkGet()
    const parsedLinkMemo = useMemo(() => getParsedCustomerLink(id, customer_type), [id, customer_type, getParsedCustomerLink])
    return { parsedLinkMemo }
}

export default useCustomerTypesDict